// @ts-nocheck
import { ButtonIcon } from "@insite/mobius/Button/Button";
import buttonTypes from "@insite/mobius/Button/buttonTypes";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { resolveColor } from "@insite/mobius/utilities";
import getContrastColor from "@insite/mobius/utilities/getContrastColor";
import { ButtonProps } from "@store/MobiusOverrides/Button/Props";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css, ThemeProps } from "styled-components";

/* Store Custom Code - Start */
import merge from "lodash/merge";
/* Store Custom Code - End */

type ButtonTypesProps<T extends (...args: any) => any> = Parameters<T>[0] & Pick<ButtonProps, "hoverTextColor">;

const baseButtonTypes = { ...buttonTypes };

merge(buttonTypes, {
    solid: (props: ButtonTypesProps<typeof buttonTypes.solid>) => {
        const contrastColor = getContrastColor(props._color, props.theme);
        const hoverTextColor = resolveColor(props.hoverTextColor, props.theme);

        return css`
            ${baseButtonTypes.solid(props)}

            ${ButtonIcon} {
                color: ${contrastColor};
            }

            &:not(:disabled):hover {
                color: ${hoverTextColor};

                ${ButtonIcon} {
                    color: ${hoverTextColor};
                }
            }
        `;
    },
    outline: (props: ButtonTypesProps<typeof buttonTypes.outline>) => { // Store Custom Code
        const mainColor = resolveColor(props._color, props.theme); // Store Custom Code
        const hoverBgColor = resolveColor("common.background", props.theme); // Store Custom Code
        const hoverColor = resolveColor(props.hoverStyle?.color, props.theme); // Store Custom Code
        const disabledColor = resolveColor("common.disabled", props.theme);
        const disabledBgColor = resolveColor("common.disabledLight", props.theme);

        return css`
            border: ${pxToRem(2)} solid ${mainColor};
            background: transparent;
            color: ${mainColor};

            &:not(:disabled):hover,
            &:not(:disabled):active {
                color: ${hoverColor};
                background-color: ${hoverBgColor};
                border-color: ${hoverColor}; /* Store Custom Code */

                ${ButtonIcon} {
                    color: ${hoverColor};
                }
            }

            &:disabled {
                background: ${disabledBgColor};
                border-color: ${disabledBgColor};
                color: ${disabledColor};
            }
        `;
    },
});
